export const isChecked = (selected: string[], value: string) => selected?.includes(value);
